import * as Sentry from '@sentry/react';
import { isAxiosError } from 'axios';
import { shouldReportError } from './should-report-error';

// logs error only when in dev and always sends to sentry
export const captureError = (error: unknown) => {
  if (shouldReportError(error)) {
    const extra = isAxiosError(error)
      ? {
          apiResponse: error.response?.data,
          apiStatus: error.response?.status,
          apiStatusText: error.response?.statusText,
          apiBaseURL: error.config?.baseURL,
        }
      : {};

    if (process.env.NODE_ENV === 'development') {
      return console.error(error, extra);
    }

    return Sentry.captureException(error, { extra });
  }
};
